import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportPointRedeemPage } from './report-point-redeem.page';

const routes: Routes = [
  {
    path: '',
    component: ReportPointRedeemPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportPointRedeemPageRoutingModule {}
